module.exports = __webpack_public_path__ + "img/Profile-2.9f0e6ae0.png";